let pendingCount = 0;
const listeners = new Set();

const notify = () => {
  listeners.forEach((listener) => {
    try {
      listener(pendingCount);
    } catch (error) {
      console.error('Loading listener failed:', error);
    }
  });
};

export const incrementLoading = () => {
  pendingCount += 1;
  notify();
};

export const decrementLoading = () => {
  pendingCount = Math.max(0, pendingCount - 1);
  notify();
};

export const getPendingCount = () => pendingCount;

export const subscribeToLoading = (listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
